import { FilterOperator } from '@jusbrasil-web/shared-apollo-client/types'

import { CommomFiltersProps, HaystackFilterProp } from './types'

const toTimestamp = (date: string | undefined) => date && new Date(date).getTime()

const formatDate = (date: Date): string =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const stringContainsNumber = (str: string) => /\d/.test(str)
const convertRangeToDays = (str = ''): number => parseInt(str.replace(/\D/g, ''), 10)

interface ParseRangeToDate {
  dateFromValue: string
  dateToValue: string
}

const parseRangeToDate = (dateRange: string | undefined): ParseRangeToDate => {
  const result = new Date()
  const days = convertRangeToDays(dateRange)
  result.setDate(result.getDate() - days)

  return {
    dateFromValue: formatDate(result),
    dateToValue: formatDate(new Date()),
  }
}

const dateRangeFilter = ({ l, dateFrom, dateTo }: CommomFiltersProps) => {
  const { dateFromValue, dateToValue } =
    l && stringContainsNumber(l)
      ? parseRangeToDate(l)
      : { dateFromValue: dateFrom, dateToValue: dateTo }

  const from = toTimestamp(dateFromValue)
  const to = toTimestamp(dateToValue)

  if (from && to) {
    return { field: 'date', operator: FilterOperator.Between, value: [from, to] }
  }

  if (from) {
    return { field: 'date', operator: FilterOperator.Greaterequalsthan, value: from }
  }

  if (to) {
    return { field: 'date', operator: FilterOperator.Lessequalsthan, value: to }
  }

  return null
}

const docIdFilter = ({ docId = [] }: CommomFiltersProps) =>
  docId.length > 0
    ? {
        field: 'docId',
        operator: FilterOperator.In,
        value: docId,
      }
    : null

const buildCommonFilters = (params: CommomFiltersProps): HaystackFilterProp[] => {
  return [dateRangeFilter(params), docIdFilter(params)].filter(Boolean) as HaystackFilterProp[]
}

export { buildCommonFilters, docIdFilter, formatDate, parseRangeToDate, toTimestamp }
